import React, { useState } from "react";
import { FaChevronDown } from "react-icons/fa";
import "./FAQsection.css";
import ContactForm from "./contact_form";

function FAQSection() {
  const faqs = [
    {
      question: "How much does it cost to repair a Wolf, Sub-Zero, or Cove appliance?",
      answer:
        "Repair costs vary depending on the appliance model, the parts needed, and labor. We offer transparent estimates and competitive pricing..."
    },
    {
      question: "How does your repair service work from start to finish?",
      answer:
        "Our service process is simple. First, you book an appointment online or by phone. Next, our factory-trained technician visits your home..."
    },
    {
      question: "How soon can I schedule an appointment for Wolf, Sub-Zero, or Cove repairs?",
      answer:
        "We understand that broken appliances can’t wait. That’s why we offer same-day or next-day service slots whenever possible..."
    },
    {
      question: "Do you guarantee your Wolf, Sub-Zero, and Cove appliance repairs?",
      answer:
        "Absolutely. We stand behind our work with a service warranty that covers both parts and labor. We use manufacturer-approved replacement parts..."
    },
    {
      question: "Why should I trust your technicians to fix my high-end appliances?",
      answer:
        "Our team specializes in repairing Wolf ovens, Sub-Zero refrigerators, and Cove dishwashers. We stay updated on the latest brand training..."
    }
  ];

  // track expanded FAQ items
  const [openStates, setOpenStates] = useState(faqs.map(() => false));

  // for the pop-up call request
  const [isCallModalOpen, setIsCallModalOpen] = useState(false);

  const toggleFAQ = (index) => {
    setOpenStates((prev) =>
      prev.map((isOpen, i) => (i === index ? !isOpen : isOpen))
    );
  };

  const openCallMeModal = (e) => {
    e.preventDefault();
    setIsCallModalOpen(true);
  };
  const closeCallMeModal = () => {
    setIsCallModalOpen(false);
  };

  return (
    <div className="faq-section">
      <h2 className="faq-title">FREQUENTLY ASKED QUESTIONS</h2>

      {faqs.map((faq, index) => (
        <div key={index} className="faq-row">
          {/* 
            1) We now place the question text and the icon side by side, 
               with the icon on the far right. 
          */}
          <div className="faq-question" onClick={() => toggleFAQ(index)}>
            <span className="faq-text">{faq.question}</span>
            <FaChevronDown
              className={`faq-icon ${openStates[index] ? "expanded" : ""}`}
            />
          </div>

          {openStates[index] && (
            <div className="faq-answer">
              {faq.answer}
            </div>
          )}
        </div>
      ))}

      <div className="faq-footer">
        Still have questions? <br />
        You can email me{" "}
        <span className="email-address">
          <a href="mailto:example@gmail.com" className="email-link">
            example@gmail.com
          </a>
        </span>{" "}
        or fill in{" "}
        <button className="call-me-link" onClick={openCallMeModal}>
          Call Request
        </button>
      </div>

      {/* The pop-up overlay */}
      {isCallModalOpen && (
        <div
          className={`call-request-overlay ${isCallModalOpen ? "open" : ""}`}
          onClick={closeCallMeModal}
        >
          <div
            className={`call-request-content ${isCallModalOpen ? "open" : ""}`}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-btn" onClick={closeCallMeModal}>
              &times;
            </button>
            <ContactForm isModal />
          </div>
        </div>
      )}
    </div>
  );
}

export default FAQSection;